import React, { useState } from "react";
import logoschool from "../../assets/images/logosignup.png";
import logomain from "../../assets/images/logomain.png";
import googleImg from "../../assets/images/google.png";

import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import useThrottledClick from "../../hooks/useThrottledClick";
import { Eye, EyeOff } from "lucide-react";
import { SchoolSignupContext } from "../../context/SchoolSignupContext";
import TrialExpiredModal from "../../components/TrialExpiredModal";
import {
	checkAndBlockIfTrialExpired,
	verifySchoolSubscriptionBlocked,
} from "../../utils/schoolSubscription";
import { useTrialExpiredModal } from "../../hooks/useTrialExpiredModal";

const LoginPassword = () => {

	const { signupData } = React.useContext(SchoolSignupContext);
	const [schoolType] = useState(signupData?.schoolType ? signupData?.schoolType : "");

	const location = useLocation();
	const navigate = useNavigate();
	const [email, setEmail] = useState(location.state?.email || "");
	const [password, setPassword] = useState("");
	const baseURL = process.env.REACT_APP_BASE_URL;
    const GOOGLE_AUTH_URL = process.env.REACT_APP_GOOGLE_AUTH_URL;

	const [, setErrorMsg] = useState("");
	const [, setShowError] = useState(false);
	const [, setLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const {
		showTrialExpiredModal,
		setShowTrialExpiredModal,
		handleTrialRenew,
		handleTrialCancel,
		cancelLoading,
	} = useTrialExpiredModal(signupData);

	async function decodeJWT(token) {
		const payload = token.split('.')[1];
		return JSON.parse(atob(payload));
	}

	const callTokenRefresh = async (token) => {
		try {
			const response = await fetch(
				`${baseURL}/user/tokenRefresh?masterTypeid=${schoolType ? schoolType : ""}`,
				{
					method: "GET",
					headers: {
						Authorization: `Bearer ${token}`,
						"Content-Type": "application/json",
					},
				}
			);

			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}

			const data = await response.json();
			return data; // 👈 MUST return data
		} catch (error) {
			console.error("❌ Error calling tokenRefresh API:", error);
		}
	};


	const handleUpdateSchool = async (user_Id, decodedTokenOld) => {
		const apiUrl = `${baseURL}/school/updateSchool`;

		const data = {
			schoolId: String(signupData.schoolId),
			userId: String(user_Id),
			schoolName: String(signupData.schoolName),
			code: String(signupData.schoolCode),
			masterTypeid: schoolType ? schoolType : "",

		};

		try {
			const response = await axios.post(apiUrl, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			});

			const schoolContext = {
				...signupData,
				schoolCode: signupData.schoolCode ?? signupData.verificationCode,
			};

			if (
				checkAndBlockIfTrialExpired(response.data, schoolContext) ||
				(response.data.code === 200 &&
					(await verifySchoolSubscriptionBlocked(baseURL, schoolContext)))
			) {
				localStorage.removeItem("access_token");
				setShowTrialExpiredModal(true);
				return;
			}

			if (response.data.code === 200) {

				//   localStorage.setItem("access_token", response.data.data);
				const storedPath = localStorage.getItem("before_school_path");

				if (storedPath && storedPath !== "null" && storedPath !== "undefined") {
					// const jwtToken = localStorage.getItem("access_token");
					// console.log(jwtToken, "jwtToken in update school");
					// console.log(decodedTokenOld, "decodedTokenOld in update school");
					let refreshToken = await callTokenRefresh(decodedTokenOld);
					localStorage.setItem("access_token", refreshToken?.data);

					// Decode token
					const decodedToken = await decodeJWT(refreshToken?.data);
					console.log("decodedToken", decodedToken);
					const userId = decodedToken.user_id;
					const masterTypeid = decodedToken.masterTypeid;
					console.log("userId", userId);

					const linkMasterTypeId = storedPath.includes("masterTypeId=") ? new URLSearchParams(storedPath.split("?")[1] || "").get("masterTypeId") : null;
					if (linkMasterTypeId !== null && linkMasterTypeId !== "" && String(masterTypeid) !== String(linkMasterTypeId)) {
						localStorage.removeItem("before_school_path");
						toast.warning("This chat was shared from a different school type. You can only view chats shared within your school type.");
						navigate("/", { replace: true });
					} else {
						localStorage.removeItem("before_school_path");
						navigate(storedPath);
						toast.success("Login successful");
					}
				} else {
					//  navigate("/");
					const jwtToken = localStorage.getItem("access_token");

					console.log(jwtToken, "jwtToken in update school")
					console.log(decodedTokenOld, "decodedTokenOld in update school")
					let refreshToken = await callTokenRefresh(decodedTokenOld);
					localStorage.setItem("access_token", refreshToken?.data);

					// Decode token
					const decodedToken = await decodeJWT(refreshToken?.data);
					console.log("decodedToken", decodedToken)
					const userId = decodedToken.user_id;
					const masterTypeid = decodedToken.masterTypeid;
					console.log("userId", userId)
					// if(userId==367 || 222){
					if (masterTypeid === 1) {

						console.log("userId id is persent", userId)
						localStorage.setItem("school_type", "tft");
						window.location.href = "/";


					} else {
						console.log("userId not tft id is persent", userId)

						localStorage.setItem("school_type", "");
						window.location.href = "/";


					}


					toast.success("Login successful");

				}
			}


			if (response.data.code !== 200) {
				if (checkAndBlockIfTrialExpired(response.data, schoolContext)) {
					localStorage.removeItem("access_token");
					setShowTrialExpiredModal(true);
					return;
				}
				toast.error(response.data.message);
				localStorage.removeItem("access_token");
				navigate("/landingpage");
			}
		} catch (error) {
			if (error.response) {
				localStorage.removeItem("access_token");
				navigate("/landingpage");
				// Server responded with an error status code
				toast.error(`❌ Error: ${error.response.data.message || 'Update failed'}`);
				console.error('Error Response:', error.response.data);
			} else {
				// Network error or no response
				toast.error('❌ Network error!');
				console.error('Error:', error.message);
			}
		}
	};


	const loginUser = async () => {
		if (!email || !password.trim()) {
			toast.error("Email and password are required");
			return;
		}

		setLoading(true);
		const baseURL = process.env.REACT_APP_BASE_URL;

		try {
			const response = await axios.post(`${baseURL}/user/login`, {
				email: email.toLowerCase(),
				password: password.trim(),
				masterTypeid: schoolType ? schoolType : "",
			}, {

				headers: {
					'Content-Type': 'application/json'
				}
			});

			const { code, data: jwtToken, message } = response.data;
			//   console.log(jwtToken,"jwtToken1")

			if (code === 200 && jwtToken) {
				console.log(jwtToken, "jwtToken")
				const decodedTokenOld = await decodeJWT(jwtToken);
				const userIdOld = decodedTokenOld.user_id;
				// const masterTypeid = decodedToken.masterTypeid;
				localStorage.setItem("access_token", decodedTokenOld);


				await handleUpdateSchool(userIdOld, jwtToken);

				// Save JWT token




			} else {
				toast.error(message || "Login failed");
				setShowError(true);
			}
		} catch (error) {

			if (error.response && error.response.status === 401) {
				localStorage.removeItem("access_token");
				toast.error("Session expired or unauthorized. Token cleared.");
			} else {
				toast.error("Login error: " + (error.message || "Something went wrong"));
			}
			console.error("Login error:", error);
			toast.error("Login error:", error);

			setErrorMsg("Something went wrong during login. Please try again.");
		} finally {
			setLoading(false);
		}
	};


	const handleGoogleLogin = () => {
		// console.log(GOOGLE_AUTH_URL, "GOOGLE_AUTH_URL Login ");
		window.location.href = GOOGLE_AUTH_URL;
		// window.location.href = "https://scsbcbacknew.makemagento.com/auth/login";

	};

	const [erroremail] = useState("");
	const [errorpassword] = useState("");

	const [throttledContinue, isLoading] = useThrottledClick(loginUser, 3000);

	return (<>
		<TrialExpiredModal
			open={showTrialExpiredModal}
			onActivatePlan={handleTrialRenew}
			onCancelSubscription={handleTrialCancel}
			cancelLoading={cancelLoading}
		/>

		<div className="school-pages-inner login-pass-iner-outer">
			<div className="school-content-page">
				{/* <img src={logoschool}/>  */}
				{schoolType === 1 ?
					<img src={logomain}
						alt="School Logo"
						style={{ cursor: "pointer" }}
						onClick={() => navigate("/school")} />
					:
					<img
						src={logoschool}
						alt="School Logo"
						style={{ cursor: "pointer" }}
						onClick={() => navigate("/school")}
					/>
				}
				<div className="schoo-outer">
					<div className="signup-outer-pagess login-pass-outer">
						<h2>Enter Your Password</h2>
						<div className="email-inner" >

							<div className="input-container">
								<input type="email"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									placeholder=" "
								/>
								<label >Email address*</label>
							</div>
							{erroremail && (
								<p className="error-message" style={{ color: "red" }}>
									{erroremail}
								</p>
							)}
							<div className="input-container forget-pass-input">
								<input
									placeholder=" "
									//   type="password"
									type={showPassword ? "text" : "password"}
									value={password}
									onChange={(e) => setPassword(e.target.value)}

								/>

								<label >Password*</label>
								<span onClick={() => setShowPassword(!showPassword)}>
									{showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
								</span>



							</div>


							{(<p className="error-message" style={{ color: "red" }}>
								{errorpassword}
							</p>)}

							{/* <PasswordStrengthBar password={password} /> */}


							{/* <p className="span-forg" onClick={(e)=>{navigate("/reset-pass",email)}}>Forget Password?</p> */}
							<p className="span-forg" onClick={() => navigate("/reset-pass", { state: { email } })}>
								Forgot Password?
							</p>



							<button className="continue-btn"
								// onClick={loginUser}
								//  onClick={handleLogin}
								onClick={throttledContinue}

							>
								{isLoading ? '⏳ Logging in...' : 'Log in '}

							</button>
						</div>


						<p className="login-account" >
							Don't have an account?

							<a
								href="/createsignup"
								//    href="/school" 
								onClick={(e) => {
									e.preventDefault(); // Prevent full page reload
									navigate("/createsignup"); // Use client-side navigation
								}}
								style={{ cursor: 'pointer' }}

							//   onClick={()=>navigate("/school")}
							>
								Sign Up
							</a>
						</p>

						<div className="or-inner" >
							<hr />
							<span >OR</span>
							<hr />
						</div>


						<div className="continue-inner-page">

							<button className="google-continue" onClick={handleGoogleLogin}>
								<img
									//   src="/google.png"
									src={googleImg}

									alt="Google" />
								<span className="left-span">
									Continue with Google</span>
							</button>



						</div>

						<p className="term-part" >
							<a href="/terms-of-use" >Terms of Use</a>  |  <a href="/privacy-policy" >Privacy Policy</a>
						</p>





					</div>

				</div>

			</div>

		</div>



	</>);

}
export default LoginPassword;